import type * as TypeBox from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import logger from './logger';

/**
  Gets JSON but unlike response.json(), this error 

  */
const getJson = (url: string, text: string) => {
  try {
    return JSON.parse(text);
  } catch (err) {
    logger().error({ err, url }, `error when converting to json, found this: ${text}`);
    throw err;
  }
};

export async function getText(endpoint: string, requestInit?: RequestInit) {
  const response = await fetch(endpoint, {
    method: 'GET',
    ...requestInit,
  });
  return await response.text();
}

export class HttpError {
  status: number;
  response: Response;
  constructor(status: number, response: Response) {
    this.status = status;
    this.response = response;
  }
}

export async function get<Schema extends TypeBox.TAnySchema>(
  endpoint: string,
  schema: Schema,
  headers?: Record<string, string>,
) {
  const response = await fetch(endpoint, {
    method: 'GET',
    headers: headers,
  });
  if (response.status >= 400) {
    throw new HttpError(response.status, response);
  }
  return await response
    .text()
    .then((text) => getJson(endpoint, text))
    .then((unknown) => Value.Decode(schema, unknown));
}

export async function post<Body, Schema extends TypeBox.TAnySchema>(
  endpoint: string,
  body: Body,
  schema: Schema,
  headers?: Record<string, string>,
) {
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body),
  });
  return await response
    .text()
    .then((text) => getJson(endpoint, text))
    .then((unknown) => Value.Decode(schema, unknown));
}
